import {observer} from 'mobx-react-lite'
import Attendance from '../Attendance'

const AttendanceManager = () => {
  return (
    <Attendance />
  )
};

export default observer(AttendanceManager);